import React, { useEffect, useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

import { useTranslation } from 'react-i18next';

import Cookies from 'js-cookie';
import ModalComponent from '@components/common/Modal';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store';
import AuthServiceApi from 'apis/api/Auth';

interface ISuccessChangePasswordModal {
  isOpen: boolean;
}

export default function SuccessChangePasswordModal(props: ISuccessChangePasswordModal) {
  const { t } = useTranslation();
  const account = useSelector((state: RootState) => state.user.account);
  const tableSetting = useSelector((state: RootState) => state.user.tableSetting);

  const handleLoginAgain = async () => {
    const iTableSetting = Object.assign({ username: account?.username }, tableSetting);
    localStorage.setItem(account?.username + '/TableSetting', JSON.stringify(iTableSetting));
    try {
      await AuthServiceApi.Logout();
    } catch (error) {
      console.log('Lout', error);
    }
    Cookies.remove('token');
    localStorage.removeItem('role');
    window.location.reload();
  };

  // sau 2.5s mà k có thao tác gì là tự nhấn luôn
  useEffect(() => {
    if (props.isOpen == true) {
      setTimeout(() => {
        handleLoginAgain();
      }, 3000);
    }
  }, [props.isOpen]);

  return (
    <ModalComponent
      modalTitle={t('Header.UserAcount.RequireLoginAgain.Title')}
      modalType="confirm"
      okText={t('Logout.Action')}
      visible={props.isOpen}
      onOk={handleLoginAgain}
      onCancel={handleLoginAgain}
    >
      <div className="mb-3 flex justify-center text-green-500">
        <FaCheckCircle size={50} />
      </div>

      <p className="text-center text-lg font-bold font-sans">{t('Header.UserAcount.RequireLoginAgain.Message1')}</p>
      <p className="text-center">{t('Header.UserAcount.RequireLoginAgain.Message2')}</p>
    </ModalComponent>
  );
}
